/* eslint-disable complexity */
import qs from 'qs';
import _ from 'lodash';
import { DeployEnv ,SLD, Site } from '@patsnap-utils/biz';
import { getCurrentLanguage } from '../language-tool';

export function safeGetLocaleStorage(key: string) {
    try {
        return localStorage.getItem(key);
    } catch (e) {
        console.error(e);
        return null;
    }
}

function getHashParams(hash: string, key: string) {
    if (hash.startsWith('/')) {
        hash = hash.substring(1);
    }
    const queryIndex = hash.indexOf('?');
    if (queryIndex !== -1) {
        const query = hash.substring(queryIndex + 1);

        const urlParams = new URLSearchParams(query);
        return urlParams.get(key);
    }
    return undefined;
}

export function getVar(key: string, type: ('string' | 'boolean') = 'string'): any {
    const hash = window.location.hash.substring(1);
    if (hash) {
        return getHashParams(hash, key);
    }
    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    if (_.has(query, key)) {
        const value = _.get(query, key) as string;
        if (_.isNull(value) || _.isUndefined(value)) {
            return true;
        }
        if (type === 'boolean') {
            if (_.lowerCase(value) === 'false') {
                return false;
            } else {
                return true;
            }
        }
        return value;
    }

    const res = safeGetLocaleStorage(key);
    if (_.isNull(res)) {
        return undefined;
    }
    return res;
}

let REGION: DeployEnv = new Site({ sld: SLD.EUREKA }).env;
const debug_region = getVar('debug_region');
if (debug_region) {
    console.warn(`使用替换Region ${REGION} => ${debug_region}`);
    REGION = debug_region;
}
export function getIsOversea() {
    return [DeployEnv.US, DeployEnv.EU].includes(REGION);
}

export function getRegion() {
    return REGION;
}

export function checkJpEnv() {
    // ?mock_region=jp/us 或者localStorage.setItem('mock_region','jp')
    const mockRegion = getVar('mock_region');
    if (mockRegion && mockRegion == 'jp') return true;
    // 1. 浏览器语言是否为日语
    const isBrowserJapanese = navigator.language.toLowerCase().startsWith('ja');

    // 2. 产品内语言是否为日语
    const isProductJapanese = getCurrentLanguage() === 'jp';

    // 3. 时区是否为 GMT+9
    // getTimezoneOffset() 返回 UTC - 本地时间（分钟），东区为负数
    const offset = new Date().getTimezoneOffset();
    const isAsiaTimezone = offset === -540; // -540 = GMT+9
    return (isBrowserJapanese || isProductJapanese) && isAsiaTimezone;

}
